import React, { useRef } from "react";

type Props = {
  children: React.ReactNode;
  expand: boolean;
  innerClassName?: string;
  style?: React.CSSProperties;
};

export default function HeightExpandDiv({
  expand,
  children,
  innerClassName,
  style,
}: Props) {
  const targetDiv = useRef<HTMLDivElement>(null);

  return (
    <div
      className="overflow-y-hidden transition-all"
      style={{
        height: expand ? targetDiv.current?.getBoundingClientRect().height : 0,
        ...style,
      }}
      data-testid="height-expand-div"
    >
      <div ref={targetDiv} className={innerClassName}>
        {children}
      </div>
    </div>
  );
}
